
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ItemTitle } from '@forzoom/item-form';
import SingleUploader from '@/components/uploader/singleUploader.vue';
import { ImageInfo } from '@forzoom/item-form/types/form';
import store from '@/store';

@Component({
    name: 'ItemTwoUploader',
    components: {
        ItemTitle,
        SingleUploader,
    },
})
export default class ItemTwoUploader extends Vue {
    /** 模式 */
    @Prop({ type: String, default: 'wechat' }) public mode!: 'input' | 'wechat';
    /** 数组格式 */
    @Prop({}) public value?: ImageInfo[];
    /** 标题 */
    @Prop({}) public title: any;
    /** 副标题 */
    @Prop({}) public titleHint: any;
    /** 上传提示 */
    @Prop({ type: Array, default() { return []; } }) public uploadHint: any;
    /** 上传函数 */
    @Prop({ required: true, type: Function }) public httpRequest!: (index: number, imageInfo: ImageInfo) => ImageInfo | Promise<ImageInfo>;
    /** 是否自动上传 */
    @Prop({ type: Boolean, default: true }) public autoUpload!: boolean;
    /** 是否通过验证 */
    @Prop({ type: Boolean, default: true }) public isValiate?: boolean;

    /** 可能存在判断出错的情况 */
    public hasUploaded: {
        [index: number]: boolean;
    } = {};

    /**
     * 添加二维码
     */
    public onAdd(index: number, imageInfo: any) {
        if (this.autoUpload) {
            this.upload(index, imageInfo);
        } else {
            this.$emit('input', imageInfo);
        }
    }
    /**
     * 删除二维码
     */
    public onRemove(index: number) {
        if (!this.value) {
            this.$emit('input', []);
        }
        this.$set(this.value!, index, null);
        this.$emit('input', this.value);
        this.$set(this.hasUploaded, index, false);
    }

    public onLoad() {
        store.commit('startRequest');
    }

    public onFinish() {
        store.commit('endRequest');
    }

    /**
     * 上传流程
     */
    public async upload(index: number, image?: ImageInfo) {
        image = image || (this.value || [])[index];
        if (this.hasUploaded[index] || !image) {
            return;
        }

        store.commit('startRequest');
        const result = await this.httpRequest(index, image);
        store.commit('endRequest');
        if (!this.value) {
            this.$emit('input', []);
        }
        this.$set(this.value!, index, result);
        this.$emit('input', this.value);
        this.$set(this.hasUploaded, index, true);
    }

    /**
     * 生命周期
     */
    public async beforeSubmit() {
        this.upload(0);
        this.upload(1);
    }

    public mounted() {
        if (this.value) {
            if (this.value[0]) {
                // @ts-ignore
                this.$refs.group.setImage(this.value[0].url);
                this.hasUploaded[0] = true;
            }
            if (this.value[1]) {
                // @ts-ignore
                this.$refs.monitor.setImage(this.value[1].url);
                this.hasUploaded[1] = true;
            }
        }
    }
}
